import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  Renderer2,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

const iconRegistry = new Map<string, string | Promise<string>>();

@Component({
  selector: 'app-flowbite-icon',
  templateUrl: './flowbite-icon.component.html',
  styleUrls: ['./flowbite-icon.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  standalone: true,
})
export class FlowbiteIconComponent implements OnInit, OnChanges {
  @Input() iconName = '';
  @Input() size = '24px';
  @Input() customClass = '';
  @Input() class = '';
  @Input() iconStyle = '';
  @Input() countInfo: number | undefined;
  svgContent = '';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.loadIcon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iconName']) {
      this.loadIcon();
    }
    if (changes['size'] || changes['color'] || changes['customClass']) {
      this.updateStyles();
    }
  }

  private async loadIcon(): Promise<void> {
    if (!this.iconName) {
      this.setSvgContent('');
      return;
    }
    const iconPath = this.getIconPath();
    const content = iconRegistry.get(iconPath);
    if (content instanceof Promise) {
      this.setSvgContent(await content);
      return;
    }
    if (undefined !== content) {
      this.setSvgContent(content);
      return;
    }
    const promise = fetch(iconPath)
      .then((response) => response.text())
      .catch((error) => {
        console.error('Error loading SVG:', error);
        return '';
      });
    iconRegistry.set(iconPath, promise);
    this.svgContent = await promise;
    this.setSvgContent(await promise);
    iconRegistry.set(iconPath, this.svgContent);
  }

  private getIconPath(): string {
    return (
      (this.iconStyle === 'filled'
        ? 'assets/icons/filled/'
        : this.iconStyle === 'regular'
          ? 'assets/icons/regular/'
          : 'assets/icons/') + `${this.iconName}.svg`
    );
  }

  private setSvgContent(content: string) {
    this.svgContent = content;
    if (content.length) {
      this.renderer.setProperty(this.el.nativeElement.querySelector('div'), 'innerHTML', this.svgContent);
      this.updateStyles();
    }
  }

  private updateStyles(): void {
    const div = this.el.nativeElement.querySelector('div');
    if (div) {
      this.renderer.setStyle(div, 'width', this.size);
      this.renderer.setStyle(div, 'height', this.size);

      if (this.customClass) {
        this.renderer.setAttribute(div, 'class', this.customClass);
      }

      const svg = div.querySelector('svg');
      if (svg) {
        svg.setAttribute('width', this.size);
        svg.setAttribute('height', this.size);
      }
    }
  }
}
